import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { JourneyProvider } from "@/context/JourneyContext";
import { Loader2 } from "lucide-react";

export default function ProtectedRoute({ children, requireActive, requireAdmin }) {
  const { user } = useAuth();
  const location = useLocation();

  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-surface" data-testid="auth-loading">
        <Loader2 className="h-8 w-8 animate-spin text-brand-accent" />
      </div>
    );
  }

  if (user === false) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  const active = user.access_status === "active" || user.access_status === "admin";
  if (requireAdmin && user.role !== "admin") {
    return <Navigate to="/dashboard" replace />;
  }
  if (requireActive && !active) {
    return <Navigate to="/dashboard" replace />;
  }

  return <JourneyProvider>{children}</JourneyProvider>;
}
